// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"ScrollLTR_Scroll__RpP1u","RTL":"ScrollLTR_RTL__2cuOD"};